import styled from "styled-components";
import React, {useMemo} from "react";
import WinrateBar from "../common/WinrateBar";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const WinRateSpan = styled.span`
  margin-left: 4px;
  width: 40px;
  font-weight: bold;
  margin-bottom: 1px;
`;

const BarWrapper = styled.div`
  width: 100px;
`;
const Percent = styled.span`
  margin-left: 3px;
  font-weight: normal;
`;

const StaticColorSpan = styled.span`
  color: ${props => props.theme.color.dark_200};
  font-size: 12px;
`;

const EventMangRankingWinRate = ({win, lose, staticColor}) => {
    const percent = useMemo(() => {
        if (win === 0 && lose === 0) {
            return <StaticColorSpan color={staticColor}>0.0</StaticColorSpan>
        }
        const result = ((win / (win + lose) * 100).toFixed(1))
        return <StaticColorSpan color={staticColor}>{result}</StaticColorSpan>
    }, [win, lose])


    return (
        <Wrapper>
            <BarWrapper className={'win-rate-bar'}>
                <WinrateBar
                    win={win}
                    lose={lose}
                />
            </BarWrapper>
            <WinRateSpan>{percent}<Percent className={'percent'}>%</Percent></WinRateSpan>
        </Wrapper>
    );
};

export default EventMangRankingWinRate;